<mat-menu #streamsMenu>
  <a mat-menu-item *ngFor="let stream of streams; trackBy: streamIdentity" routerLink="/live/streams/{{stream.id}}">
    <ng-container *ngIf="stream.active_live_event?.show">
      [{{stream.active_live_event.show.name}}]
    </ng-container>
    {{stream.title || stream.active_live_event?.title}}
  </a>
</mat-menu>
<app-spinner *ngIf="!stream"></app-spinner>
<ng-container *ngIf="stream">

  <div class="more-streams" *ngIf="showMoreStreams">
    <div class="actions">
      <h2>Active Live Streams</h2>
      <div class="spacer"></div>
      <button mat-raised-button color="primary" (click)="refresh()" [disabled]="!this.streams || refreshDisallowed">
        <ng-container *ngIf="refreshing">
          <mat-icon>sync</mat-icon>
          Refreshing...
        </ng-container>
        <ng-container *ngIf="!refreshing">
          <ng-container *ngIf="refreshDisallowed">
            <mat-icon>check</mat-icon>
            Refreshed
          </ng-container>
          <ng-container *ngIf="!refreshDisallowed">
            <mat-icon>sync</mat-icon>
            Refresh
          </ng-container>
        </ng-container>
      </button>
      <button mat-icon-button (click)="showMoreStreams = false">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <ng-container *ngIf="!streams">
      <div class="loading-state">
        <app-spinner class="inline"></app-spinner>
      </div>
    </ng-container>
    <ng-container *ngIf="streams && stream">
      <div class="stream" [class.current]="otherStream.id === stream.id" *ngFor="let otherStream of streams">
        <div class="title">
          <h3>
            {{otherStream.title || otherStream.active_live_event?.title}}
          </h3>
          <div class="spacer"></div>
          <div class="actions">
            <a *ngIf="stream.id !== otherStream.id" mat-menu-item routerLink="/live/streams/{{otherStream.id}}">
              <mat-icon>play_arrow</mat-icon>
              Watch Now
            </a>
          </div>
        </div>

        <div class="meta">
          <tyt-content-badge [premium]="otherStream.premium" type="live"></tyt-content-badge>
          <tyt-tag class="event">
            <div class="label">
              Started:
            </div>
            <tyt-timestamp [value]="otherStream.started"></tyt-timestamp>
          </tyt-tag>
          <tyt-tag class="event" *ngIf="otherStream.active_live_event">
            Now Playing: {{otherStream.active_live_event.show?.name || otherStream.active_live_event.title }}
          </tyt-tag>
          <tyt-tag class="event" *ngIf="getUpcomingEvents(otherStream).length > 0">
            Coming Up:
              <span class="event-instances">
                <span class="event-instance" *ngFor="let event of getUpcomingEvents(otherStream)">
                  {{event.show?.name || event.title}}
                </span>
              </span>
          </tyt-tag>
          <tyt-tag class="event" *ngIf="getUpcomingEvents(otherStream).length === 0">
            This is the last event of the stream
          </tyt-tag>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="current-event title-block">
    <div class="title">
      <div class="stream-status">
        <div class="live-button" *ngIf="stream.finished == null">
          <tyt-live-tag></tyt-live-tag>
        </div>
        <div class="ended-button" *ngIf="stream.finished != null">
          <span>Ended</span>
        </div>
      </div>

      <h1>{{stream.title || stream.active_live_event?.title}}</h1>

      <div class="spacer"></div>

      <div class="stream-meta">
        <ng-container *ngIf="stream.premium">
          <tyt-plus-tag text="Members Only Stream" matTooltip="You are watching the members only stream."></tyt-plus-tag>
        </ng-container>
        <ng-container *ngIf="!stream.premium">
          <tyt-tag>Public Stream</tyt-tag>
        </ng-container>

        <a mat-button (click)="showMoreStreams = true" *ngIf="!showMoreStreams">More Streams</a>
        <a mat-button target="_blank" routerLink="/live/schedule">Schedule</a>
      </div>
    </div>
  </div>

  <div class="schedule-block">
    <div class="player" [class.has-paywall]="paywallVisible">
      <div class="technical-difficulties" *ngIf="technicalDifficulties">
        <div class="image">
          <img src="/assets/mariguana.png" />
        </div>
        <div class="details">
          We're working on restoring the live stream.<br />
          Back shortly, please stand by!<br />

          <div *ngIf="technicalDifficultiesTimeBeforeTryAgain > 0" style="margin-top: 1em; font-size: 75%;">

            <span class="no-mobile">
              <br />
              Help keep TYT.com up and running by <strong style="color: yellow; font-size: 110%">refraining from
                excessive page reloads</strong>
              while you wait for the issue to be resolved.<br />
              <br />
              <br />
            </span>

            <a href="javascript:;" style="opacity: 0.6; cursor: not-allowed;">Try again in
              {{technicalDifficultiesTimeBeforeTryAgain}} seconds</a>
          </div>

          <a *ngIf="technicalDifficultiesTimeBeforeTryAgain <= 0" href="javascript:window.location.reload();">Try
            again</a>
        </div>
      </div>
      <media-player *ngIf="!technicalDifficulties" [isLive]="true" [inline]="true" [useDarkTheme]="useDarkMode"
        (newSession)="session = $event" (paywallVisible)="paywallVisible = $event"
        (newChatEmbed)="platformChat = $event" #player></media-player>
    </div>
    <div class="current-event">

      <div id="play-options" [class.open]="showPlaybackOptions">
        <a class="opener" href="javascript:;" (click)="showPlaybackOptions = !showPlaybackOptions"
          aria-label="Playback Options">
          <mat-icon>settings</mat-icon>
          <span class="options-label" *ngIf="showPlaybackOptions">Playback Options</span>
          <div class="spacer">
          </div>
          <mat-icon *ngIf="showPlaybackOptions">expand_less</mat-icon>
          <mat-icon *ngIf="!showPlaybackOptions">expand_more</mat-icon>
        </a>
        <div class="option-list">
          <hr />
          <a href="{{session.popOutURL}}" target="_blank" (click)="popOut()" *ngIf="playbackServiceId == 'youtube'">
            <mat-icon>open_in_new</mat-icon>
            Watch on YouTube
          </a>
          <a href="javascript:;" (click)="showComments = !showComments">
            <mat-icon>comment</mat-icon>
            <ng-container *ngIf="!showComments">Show Comments</ng-container>
            <ng-container *ngIf="showComments">Hide Comments</ng-container>
          </a>
          <a href="javascript:;" (click)="showChat = !showChat"
            *ngIf="stream.premium && playbackServiceId == 'youtube'">
            <mat-icon>chat</mat-icon>
            <ng-container *ngIf="!showChat">Show Chat</ng-container>
            <ng-container *ngIf="showChat">Hide Chat</ng-container>
          </a>
        </div>
      </div>

      <div class="info-note" *ngIf="stream && stream.finished != null">
        <h1>This stream has ended</h1>
        <p>Not all of our live streams can be replayed after they are completed. Please check out our <a
            routerLink="/live/schedule">Live Schedule</a>
          to see when you can catch our next show!</p>
        <div style="text-align: right;">
          <a routerLink="/" mat-raised-button color="primary" >Go Home</a>
        </div>
      </div>
      <div class="info-note" *ngIf="stream && actionableUpgradeStream">
        <a class="close" href="javascript:;" (click)="actionableUpgradeStream = null">
          <mat-icon>close</mat-icon>
        </a>
        <ng-container *ngIf="freeStreamPrompt == 'unentitled'">
          <h1>This stream is free</h1>
          <p>...but there's more of it if you <a href="{{joinUrl}}">become a TYT member!</a></p>

          TYT members can:
          <ul>
            <li>Watch all parts of today's show uninterrupted</li>
            <li>Post comments on this show and any content you find on TYT.com</li>
            <li>Enjoy members-only chat</li>
          </ul>

        </ng-container>
        <ng-container *ngIf="freeStreamPrompt == 'anonymous'">
          <h1>Are you a member?</h1>
          <p>This live event has streams for both members and non-members,
            and you are currently watching the <strong>non-members version</strong> because you are not logged in.</p>
          <p><a routerLink="/login">Login</a> with your TYT membership or <a href="{{joinUrl}}">sign up now</a>!</p>

          TYT members can:
          <ul>
            <li>Watch all parts of today's show uninterrupted</li>
            <li>Post comments on this show and any content you find on TYT.com</li>
            <li>Enjoy members-only chat</li>
          </ul>
        </ng-container>
        <ng-container *ngIf="freeStreamPrompt == 'entitled'">
          <h1>Hello TYT Member!</h1>
          <p>Looking for the members-only live stream? You are watching the free, public
            stream of this event, but a members-only stream is available! </p>
          <p>Did you know? You can watch all public portions of the show from the members-only stream,
             so that you don't have to switch when the members-only portion starts!</p>

          <a routerLink="/live/streams/{{upgradeStream.id}}">Click here to go the members-only version!</a>
        </ng-container>
      </div>
    </div>

    <div class="row bottom-area">
      <div class="col-md-8" *ngIf="showComments">
        <tyt-comments [identifier]="topicIdentifier" [shareTitle]="topicTitle"></tyt-comments>
      </div>
      <div [class.col-md-4]="showComments" [class.col-md-12]="!showComments">
        <div class="sub-sidebar">
          <div class="chat-embed-container">
            <ng-container *ngIf="!stream.premium && upgradeStream">
              <div class="chat-header">Members-Only Chat</div>

              <div class="info-note">
                <a href="{{joinUrl}}">Join TYT</a> to chat on the <a
                  routerLink="/live/streams/{{upgradeStream.id}}">members-only live stream</a>. *

                <br />
                <br />
                <small>
                  * Requires a Google account.<br />
                  &nbsp;&nbsp;&nbsp;&nbsp;<a href="javascript:;" (click)="showChatNotes = true">Learn More</a>
                </small>
              </div>
            </ng-container>
            <ng-container *ngIf="showChat && platformChat && stream.premium">
              <div class="chat-header">Members-Only Chat</div>

              <ng-container *ngIf="useBantaChat">
                <tyt-chat identifier="live:{{stream.id}}"></tyt-chat>
              </ng-container>
              <ng-container *ngIf="!useBantaChat">
                <div class="chat-embed" [innerHTML]="platformChat"></div>
                <br />
                <em style="font-size: 80%;">
                  Dark Mode for Chat: Member's Chat on TYT.com follows YouTube's Dark Theme setting.
                  <a href="javascript:;" (click)="showDarkThemeNotes = true">Learn More</a><br />
                </em>
                <div *ngIf="showDarkThemeNotes">
                  <ul>
                    <li>
                      <strong>My Member's Chat is light themed! Can I make it dark?</strong><br />
                      Yes, if you go to YouTube.com, click your avatar in the upper right, and toggle Dark Theme on in
                      that menu,
                      the chat embed will be dark themed here on TYT.com. Unfortunately we can no longer override your
                      main YouTube.com
                      setting to make Member Chat fit our always-dark theme.<br />
                    </li>
                  </ul>
                </div>
                <em style="font-size: 80%;">
                  Note: Live chat is powered by YouTube, so you will need a Google account to use it.
                  <a href="javascript:;" (click)="showChatNotes = true">Learn More</a><br />
                </em>
              </ng-container>
              <div *ngIf="showChatNotes">
                <ul>
                  <li>
                    <strong>I don't want to use my real name</strong><br />
                    If you are not comfortable chatting with a real Google account identity, YouTube supports <a
                      target="_blank" href="https://support.google.com/youtube/answer/2897336?hl=en">brand
                      accounts</a> which allow you to chat under a pseudonym.
                    In the future you will only need your TYT account!<br />
                  </li>
                </ul>
              </div>
            </ng-container>

            <br />
            <br />
          </div>
          <div class="donate-promo-container" *ngIf="showDonatePromos && showComments">
            <a class="close" href="javascript:;" (click)="showDonatePromos = false">
              <mat-icon>close</mat-icon>
            </a>
            <a class="donate-promo" href="https://secure.actblue.com/donate/tytnetwork" target="_blank">
              <div>
                <img src="/assets/yes-button-baked.svg" />
                Help TYT continue producing truly independent journalism
              </div>
            </a>
          </div>
          <ng-container *ngIf="stream.live_events && stream.live_events.length > 0">

            <tyt-feed-tag>Events in this stream</tyt-feed-tag>

            <div class="schedule-item" *ngFor="let item of stream.live_events">
              <div class="avatar" [responsiveBackgroundImage]="item.show.logo_square"></div>

              <div class="spacer">
                <h2>
                  <ng-container *ngIf="item">
                    {{item.show.name}}
                  </ng-container>
                </h2>
                <tyt-plus-tag *ngIf="item.is_premium" [state]="item.unlock_premium ? 'unlocked' : 'locked'"></tyt-plus-tag>
              </div>
              <div class="watch" *ngIf="stream.active_live_event && stream.active_live_event.id == item.id">
                <tyt-live-tag></tyt-live-tag>
              </div>
              <div class="time" *ngIf="!stream.active_live_event || stream.active_live_event.id != item.id">
                {{item.air_time_unix * 1000 | date : 'h:mm a'}} {{timezoneString}}
              </div>
            </div>
          </ng-container>
        </div>

      </div>
    </div>
  </div>
</ng-container>

<tyt-staging-note title="Developer Tools" [shown]="true">
  <a href="javascript:;" (click)="devShowUpgrade()">Members-Only Upgrade</a>
</tyt-staging-note>

<tyt-staging-note title="Live Stream (JSON)" [shown]="false">
  <pre>{{ stream | json }}</pre>
</tyt-staging-note>